const MLN = [
    {id: "0", value: "多方"},    
    {id: "1", value: "空方"},    
    {id: "2", value: "盤整"}, 
  ];  
  
  export default MLN